import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from '@rescui/button';
import { DownIcon } from '@rescui/icons';


import RemoveFeatureConfirmation from './RemoveFeatureConfirmation';
import { getAllTransitiveParents } from '../services/helper';
import { Dropdown } from '@rescui/dropdown';

const FeatureItemAction = ({
  feature,
  removeFeature,
  addFeature,
  isAlwaysShown,
  size,
}) => {
  const [showActionButtonDropdown, setShowActionButtonDropdown] =
    useState(false);

  const toggleActionDropdown = useCallback(() => {
    setShowActionButtonDropdown(!showActionButtonDropdown);
  }, [showActionButtonDropdown]);

  const doAddFeature = useCallback(
      (e) => {
        addFeature();
        e.stopPropagation();
      },
      [addFeature],
  );

  const actionButtonDefaultProps = useMemo(
      () => ({
        className: cn('plugin-item__button', {
          'plugin-item__button_shown': showActionButtonDropdown || isAlwaysShown,
        }),
        theme: 'dark',
        size: size || 'm',
      }),
      [showActionButtonDropdown, isAlwaysShown],
  );

  const dependents = useMemo(() => {
    return feature.wasAdded ?
      getAllTransitiveParents(feature).filter((parent) => parent.wasAdded) :
      [];
  }, [feature]);

  if (!feature.wasAdded) {
    return (
      <Button {...actionButtonDefaultProps} onClick={doAddFeature}>
        Add
      </Button>
    );
  }

  if (!dependents.length) {
    return (
      <Button
        {...actionButtonDefaultProps}
        onClick={() => removeFeature([feature.id])}
      >
        Remove
      </Button>
    );
  }

  return (
    <Dropdown
      trigger={
        <Button
          icon={<DownIcon />}
          {...actionButtonDefaultProps}
          onClick={toggleActionDropdown}
          iconPosition="right"
        >
          Remove
        </Button>
      }
      isOpen={showActionButtonDropdown}
    >
      <RemoveFeatureConfirmation
        feature={feature}
        dependents={dependents}
        removeFeature={removeFeature}
      />
    </Dropdown>
  );
};

FeatureItemAction.propTypes = {
  feature: PropTypes.object,
  isAlwaysShown: PropTypes.bool,
  addFeature: PropTypes.func,
  removeFeature: PropTypes.func,
  size: PropTypes.string,
};

export default FeatureItemAction;
